import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalPresentismoService } from './modal-presentismo.service';
import { DatabaseService } from '@app/database/database.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-presentismo',
  templateUrl: './modal-presentismo.component.html',
  styleUrls: ['./modal-presentismo.component.scss']
})
export class ModalPresentismoComponent implements OnInit {

  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  submitted = false;
  enviandose = false;
  isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
  trabajadorFirmaB64; 
  trabajadorFirmaSigString;
  @Output() asistenciaUpdate = new EventEmitter<any>();
  @Output() closeModalPresente = new EventEmitter<any>();
  @Output() refreshList = new EventEmitter<any>();

  constructor(
    private modalPresentismoService: ModalPresentismoService,
    private databaseService: DatabaseService,
    private backgroundSyncService: BackgroundSyncService,
    private messageAlertServices: MessageAlertService,
    private router: Router,
  ) { }

  @Input() nombreTrabajador: string;
  @Input() nombreEstudio: string;
  @Input() numeroEstudio: string;
  @Input() fecha: string;
  @Input() hora: string;
  @Input() card: any;
  @Input() displayModalFirma = false;
  private _displayModalPresente = true;

  get displayModalPresente() {
    return this._displayModalPresente;
  }

  @Input()
  set displayModalPresente(val) {
    this._displayModalPresente = val;
  }

  showModalPresente(){
    this._displayModalPresente = true;
  }

  closeModalPresentismo(){
    this._displayModalPresente = false;
    this.closeModalPresente.emit(false);
  }

  ngOnInit(): void {
    let now = new Date();
    this.fecha = this.formatDate(now);
    this.hora = now.getHours() + ':' + now.getMinutes();
  }

  formatDate(now: Date) : string{
    let day = now.getDate();
    let month = now.getMonth() + 1;
    let year = now.getFullYear();

    let dayString = day < 10 ? `0${day}` : `${day}`;
    let monthString = month < 10 ? `0${month}` : `${month}`;

    let formattedDate = `${dayString}/${monthString}/${year}`;

    return formattedDate;
  }

  showModalFirma(){
    this.displayModalFirma = true;
    /**
     *  Simulación de firma para desarrollo
     * Ya que no es posible utilizar el pad de firmas debemos simularla.
     * En caso de tener que desarrollar en relacion a la firma basta con
     * descomentar esta seccion de codigo y comentar 
     * this.displayModalFirma = true;
     */

    /** 
    *this.trabajadorFirmaB64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';
    *this.trabajadorFirmaSigString = 'MOCK_SIGNATURE_' + Date.now();
    *this.submitPresente();
    */
  }

  closeModalFirma(){
    this.displayModalFirma = false;
    if(this.trabajadorFirmaB64 && this.trabajadorFirmaSigString){
      this.submitPresente();
    }
  }

  submitPresente(){
    this.closeModalPresentismo();
    this.submit();
  }

  recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
    this.trabajadorFirmaB64 = datos.firmaB64;
    this.trabajadorFirmaSigString = datos.firmaSigString;
  }

  async submit(): Promise<any> {
    this.submitted = true;
    this.enviandose = true;
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    if (this.isOnline) {
      this.saveToOnline();
    } else {
      this.saveToOffline();
    }
  }

  private saveToOnline(): void {
    var dataToSend = this.buildRequest();
    this.modalPresentismoService
      .loadPresente(dataToSend, 'estudios/presente')
      .subscribe(
        async (response) => {
          const tabla = `examenes` + (this.card.lote.reevaluacion ? `Reevaluacion` : `Periodicos`);
            
          let examen = await this.databaseService.getSingleExamenItem(tabla, +dataToSend.examenNumero);
          examen = this.modifyExamPresente(examen, dataToSend);
          this.databaseService.editTableItem(+dataToSend.examenNumero, tabla, examen);
          this.databaseService.editTableItem(+dataToSend.examenNumero, tabla + `Filtrados`, examen);
          
          this.messageAlertServices.setMessage(0, {
            severity: 'success',
            detail: 'Presente registrado',
          });
          this.asistenciaUpdate.emit({asistencia:"Presente", refreshList: true});
        },
        (error) => {
          this.messageAlertServices.setMessage(0, {
            severity: 'error',
            detail: "Ocurrió un error al registrar el presente.",
          });
          this.asistenciaUpdate.emit({asistencia:"Asistencia"});
          console.log(error);
        }
      );
  }

  private saveToOffline(): void {
    let dataToSend;
    dataToSend = this.buildRequest();
    dataToSend.table = `examenes` + (this.card.lote.reevaluacion ? `Reevaluacion` : `Periodicos`);
    
    this.databaseService
      .setExamenOnPresentismoPorEnviarTable(dataToSend, this.modalPresentismoService.buildUrlApi('estudios/presente'))
      .then(async (response) => {
        let examen = await this.databaseService.getSingleExamenItem(dataToSend.table, +dataToSend.examenNumero);
        examen = this.modifyExamPresente(examen, dataToSend);
        this.databaseService.editTableItem(+dataToSend.examenNumero, dataToSend.table, examen);
        this.databaseService.editTableItem(+dataToSend.examenNumero, dataToSend.table + `Filtrados`, examen);
        
        this.messageAlertServices.setMessage(0, {
          severity: 'success',
          detail: 'Se registrará el presente cuando se retome la conexión.',
        });
        this.asistenciaUpdate.emit({asistencia:"Presente"});
      })
      .catch((e) => {
        this.messageAlertServices.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Ha ocurrido un error. Por favor reinitente más tarde y disculpe las molestias ocasionadas',
          key: 'presente',
        });
      });
  }

  buildRequest() {
    const object = {
      userId : this.currentUser.userId,
      username : this.currentUser.username,
      modelId : this.currentUser.modelId,
      tipoEstudio : this.nombreEstudio,
      examenNumero : this.numeroEstudio,
      firmaB64 : this.trabajadorFirmaB64,
      firmaSigString : this.trabajadorFirmaSigString,
    }
    return object;
  }

  returnToExams(ruta?): void {
    this.router.navigate([ruta ? ruta : 'examenes']);
  }

  modifyExamPresente( examen: any, dataModificada: any){
    examen.firmaB64 = dataModificada.firmaB64;
    examen.firmaSigString = dataModificada.firmaSigString;
    examen.asistencia = 'Presente';
    examen.motivoCierre = null;

    return examen;
  }

}
